const CONSTANTS = {
    REFRESH_STATUS: 'REFRESH_STATUS',
    REFRESH_LOADING: 'REFRESH_LOADING',
    REFRESH_IS_FETCHING: 'REFRESH_IS_FETCHING',
    REFRESH_SUBMIT: 'REFRESH_SUBMIT',
    REFRESH_APPLY_COUPON: 'REFRESH_APPLY_COUPON',
    REFRESH_CART: 'REFRESH_CART',
    REFRESH_DELIVERY_VALIDATION: 'REFRESH_DELIVERY_VALIDATION',
    REFRESH_DELIVERY_LOADING: 'REFRESH_DELIVERY_LOADING',
    REFRESH_RATE_ID: 'REFRESH_RATE_ID',
    REFRESH_FETCH_DELIVERY: 'REFRESH_FETCH_DELIVERY',
}

export default CONSTANTS